const HelloApp = () => {
  return <div>Hello</div>;
};

export default HelloApp;
